import { useQuery } from "react-query";
import AccountsApis from "../shared/apiHandlers/AccountsAPIs";
import { User } from "../shared/interfaces/User";

export function useUsers() {
  const accountApis = new AccountsApis({
    onAuthError: () => "Error getting users",
  });

  return useQuery<User[], Error>(
    "getUsers",
    async () => {
      try {
        return await accountApis.getUsers();
      } catch (error: unknown) {
        if (error instanceof Error) {
          throw error;
        }
        throw new Error("Error getting users");
      }
    },
    {
      onError: (error: Error) => {
        throw new Error(error.message);
      },
    },
  );
}
